import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import TypeChart from "./TypeChart";


type Type = {
    x: string,
    y: number,
    id: string
}

export default function TypeCharts(){
    const [materia, setMateria] = useState<Type>();
    return(
        <>
            <Row className="justify-content-center">
                <Col xs={12}>
                    <TypeChart setHook={setMateria} />
                </Col>
            </Row>
            {
                materia &&
                <Row>
                    <Col xs={12}>
                        <TypeChart materia={materia} />
                    </Col>
                </Row>
            }
        </>
    )
}